import { Tab, TabList, TabPanel, TabPanels, Tabs } from "@chakra-ui/react"

// Parts
import Downlines from "./downlines"
import NetworkTab from './network'

export default function Network(){
    return(
    <Tabs isLazy size="sm" colorScheme="orange" variant="solid-rounded">
        <TabList>
            <Tab>Downlines</Tab>
            <Tab>Rede</Tab>
        </TabList>
        <TabPanels>
            <TabPanel><Downlines /></TabPanel>
            <TabPanel><NetworkTab /></TabPanel>
        </TabPanels>
    </Tabs>
    )
}